import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=700f0f5e&scoped=true"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSettings.vue?vue&type=style&index=0&id=700f0f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f0f5e",
  null
  
)

export default component.exports